// extracted by mini-css-extract-plugin
module.exports = {"block":"DefaultImage_block__11kjk","square":"DefaultImage_square__iMDjI","content":"DefaultImage_content__13t9x"};